var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _path3, _path4, _rect, _rect2, _rect3, _polygon, _path5, _polygon2, _path6, _path7, _circle, _path8, _path9, _polygon3, _path10, _path11, _path12, _path13, _polygon4, _circle2, _circle3, _circle4, _circle5, _circle6, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawProgressDataReRv4P(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 868.1322,
    height: 572.67934,
    viewBox: "0 0 868.1322 572.67934",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M969.807,735.7308l.95117-1.75879c-12.75342-6.89746-28.62573-15.481-36.916-29.56738-8.17237-13.88623-8.35572-32.74268-.47852-49.21094,6.70361-14.01563,19.01782-26.57227,35.61108-36.313,3.273-1.92139,6.70874-3.74219,10.0315-5.50342,8.03149-4.25634,16.33642-8.6582,23.18432-14.90283,9.43164-8.60107,16.56788-23.03467,11.249-35.89111a23.85569,23.85569,0,0,0-20.67749-14.46729l-.1128,1.99707a21.86063,21.86063,0,0,1,18.94776,13.24805c4.94263,11.94727-1.83862,25.50488-10.75415,33.63574-6.66065,6.07373-14.85181,10.415-22.7732,14.61328-3.34155,1.771-6.79711,3.60254-10.10766,5.5459-16.93848,9.94336-29.52637,22.79785-36.40259,37.17432-8.1604,17.06054-7.94629,36.63672.55908,51.08887C940.69132,719.98519,956.83512,728.71615,969.807,735.7308Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#f1f1f1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 814.15244,
    cy: 386.49688,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800.15244,
    cy: 442.49688,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 832.15244,
    cy: 451.49688,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 782.15244,
    cy: 498.49688,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 747.15244,
    cy: 498.49688,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M756.67618,512.12436a8.00164,8.00164,0,0,0,6.79995-10.21293l23.13873-16.52765-13.7895-5.30973-19.85885,16.509a8.045,8.045,0,0,0,3.70967,15.54134Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#ffb7b7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M769.52217,501.23908l-7.676-13.11025.163-.1859,30.97067-35.25912L817.02626,411.676l20.88121,2.66137.3081,6.31172-.06236.09429-33.17516,49.8699-.03528.03009Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M763.05652,511.6431l-41.48791,23.48047-30.36135-53.64583,41.48791-23.48046Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#e5e5e5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 708.72568,
    y: 484.4256,
    width: 25.56265,
    height: 4.39231,
    transform: "translate(-312.02828 254.83699) rotate(-29.50809)",
    fill: "#6c63ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 714.35056,
    y: 494.36427,
    width: 25.56265,
    height: 4.39231,
    transform: "translate(-316.19391 258.89669) rotate(-29.50809)",
    fill: "#6c63ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 719.97544,
    y: 504.30294,
    width: 25.56265,
    height: 4.39231,
    transform: "translate(-320.35954 262.95639) rotate(-29.50809)",
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "705.915 559.425 694.107 559.425 688.489 513.877 705.917 513.878 705.915 559.425",
    fill: "#ffb7b7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M874.86067,734.53223l-38.07617-.00141v-.4816a14.82108,14.82108,0,0,1,14.82031-14.82007h.00094l23.25562.00094Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "604.285 559.039 592.8 556.296 597.913 510.689 614.864 514.737 604.285 559.039",
    fill: "#ffb7b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M770.49036,734.53223l-37.035-8.84335.11183-.46844a14.82112,14.82112,0,0,1,17.85667-10.9734l.00091.00022,22.61969,5.40129Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M816.11291,390.85205V370.975a26.6353,26.6353,0,1,1,53.27059,0v19.87708a3.58191,3.58191,0,0,1-3.57787,3.57788H819.69079A3.58191,3.58191,0,0,1,816.11291,390.85205Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 670.24078,
    cy: 210.93947,
    r: 19.52807,
    fill: "#ffb7b7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M809.81164,372.56513a21.09354,21.09354,0,0,1,21.06971-21.06971H834.857a21.09337,21.09337,0,0,1,21.06952,21.06971v.39755h-8.40137l-2.86548-8.02383-.573,8.02383h-4.3419l-1.44575-4.04841-.28923,4.04841H809.81164Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M847.5653,477.66724,797.844,475.77486,795.06428,443.246c-2.14364-5.954-2.17841-11.06608-.10281-15.19387a15.2086,15.2086,0,0,1,8.39652-7.25725l10.87968-13.14034a14.80868,14.80868,0,0,1,11.49838-5.35951l28.26685.19325c.68189-.40991,4.81453-2.51025,12.96564,1.02309,8.8412,3.8329,6.78817,17.14443,6.76627,17.27816l-.02023.125-.09713.08225-18.80327,15.83447Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "632.306 308.619 608.787 351.499 590.956 546.581 611.102 552.734 646.764 400.129 688.15 548.404 712.3 549.009 695.857 377.898 681.487 311.649 632.306 308.619",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M861.075,541.69843a8.00163,8.00163,0,0,0-.42123-12.26238l9.18182-26.91205L855.534,506.23978l-6.52662,24.98647A8.045,8.045,0,0,0,861.075,541.69843Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#ffb7b7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M865.17647,525.36726l-13.87573-6.18534,4.66241-46.94574-4.33893-47.33893,18.52359-9.99952,3.92669,4.95094.004.11234,2.08062,59.86074-.011.04547Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M664.09593,381.82216H165.9339V163.66033h498.162Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M664.09593,381.82216H165.9339V163.66033h498.162Zm-493.343-4.819h488.524V168.47934h-488.524Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#e5e5e5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.285 175.642 163.756 111.579 79.396 174.766 77.465 172.189 163.756 107.556 248.877 171.313 333.465 78.746 333.805 78.609 419.13 44.23 420.333 47.217 335.348 81.458 249.285 175.642",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.4303,
    cy: 173.47741,
    r: 9.65947,
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.75566,
    cy: 110.69083,
    r: 9.65947,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.08102,
    cy: 173.47741,
    r: 9.65947,
    fill: "#6c63ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.40637,
    cy: 80.10249,
    r: 9.65947,
    fill: "#6c63ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 419.73173,
    cy: 44.68442,
    r: 9.65947,
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.0661,736.33967h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-165.9339 -163.66033)",
    fill: "#cbcbcb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProgressDataReRv4P);
export default __webpack_public_path__ + "static/media/undraw_progress_data_re_rv4p.ed923cf7220547b58e42d96852d84b43.svg";
export { ForwardRef as ReactComponent };